import {Requester} from "./Requester";

export class Form6Play {
    requester: Requester;
    formId: string;
    subject: string;
    problematic: string;
    text: string;
    operator: string;
    system: string;
    device: string;
    osVersion: string;
    navigator: string;
    captcha: string;

    constructor(requester: Requester, formId: string, subject: string, problematic: string, text: string, operator: string,
                system: string, device: string, osVersion: string, navigator: string, captcha: string) {
        this.requester = requester;
        this.formId = formId;
        this.subject = subject;
        this.problematic = problematic;
        this.text = text;
        this.operator = operator;
        this.system = system;
        this.device = device;
        this.osVersion = osVersion;
        this.navigator = navigator;
        this.captcha = captcha;
    }
}
